import * as React from 'react'
import styled from 'styled-components'
import { Tabs } from 'components/molecules/Tabs'
import { FetchablePostList } from 'components/organisms/FetchablePostList'

import { BREAKPOINT_TABLET_SMALL, BREAKPOINT_TABLET_LARGE } from '../../static/constants'

import * as constants from '../../static/constants'

import { IUser } from 'static/interfaces'

interface IProps {
  user?: IUser
}

interface IOption {
  id: 'group' | 'private'
  label: string
}

const options: IOption[] = [
  {
    id: 'group',
    label: 'Group Tours',
  },
  {
    id: 'private',
    label: 'Private Tours',
  },
]

const PostTabs: React.FC<IProps> = ({ user }) => {
  const [currentDetailId, setCurrentDetailId] = React.useState('group')
  const onChangeTab = async (id: string) => {
    setCurrentDetailId(id)
  }

  return (
    <PostTabsWrapper>
      <Tabs current={currentDetailId} options={options} handleSelect={onChangeTab} />

      <h2 className="boxTitle">
        Most Popular Experiences in <span>Japan</span>
      </h2>

      <FetchablePostList
        key={currentDetailId}
        user={user}
        filter={{ post_types: [currentDetailId], include_member: false }}
      />
    </PostTabsWrapper>
  )
}

const PostTabsWrapper = styled.div`
  padding: 0 0 64px;
  margin: -60px 0 0;
  @media screen and (max-width: ${BREAKPOINT_TABLET_LARGE}px) {
    margin: -94px 0 0;
  }
  @media screen and (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
    padding: 0 0 64px;
    margin: -80px 0 0;
  }
  > div {
    padding: 0;
  }

  .Tab {
    font-weight: 700;
    font-size: 20px;
    line-height: 1.4;
    text-align: center;
    color: #ffffff;
    border: 0;
    background: none;
    transition: all 0.3s ease 0s;
    padding: 18px 20px;
    min-width: 200px;
    border-radius: 8px 8px 0 0;
    @media screen and (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
      font-size: 16px;
      padding: 15px;
      min-width: 140px;
    }
    &.active,
    &:hover {
      border: 0;
      background: #ffffff;
      color: #00896c;
    }
  }

  .boxTitle {
    font-weight: 700;
    font-size: 30px;
    line-height: 32px;
    margin: 55px 0 36px;
    color: #212529;
    span {
      color: #00896c;
    }

    @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      margin-bottom: 20px;
      font-size: 20px;
      line-height: 22px;
      margin: 35px 0 36px;
    }
  }
`

export default PostTabs
